import _slicedToArray from "/opt/build/repo/web/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import * as React from 'react';
import { useWillUnMountEffect } from '.';
/**
 * set up a timeout which is cleared automatically when the component unmounts
 * @param time the time to pass before the callback is fired
 * @param callback the callback to run after the given time
 */

export function useTimeout(callback, time) {
  var timeout = React.useRef();

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      waiting = _React$useState2[0],
      setWaiting = _React$useState2[1];

  var resolvePromise = React.useRef();
  var clear = React.useCallback(function () {
    var _a;

    clearTimeout(timeout.current);
    (_a = resolvePromise.current) === null || _a === void 0 ? void 0 : _a.call(resolvePromise, undefined);
    resolvePromise.current = undefined;
  }, []);
  var set = React.useCallback(function (overrideCallback, overrideTime) {
    clear();
    return new Promise(function (resolve) {
      setWaiting(true);
      resolvePromise.current = resolve;
      timeout.current = setTimeout(function () {
        var _a;

        setWaiting(false);
        var value = (_a = overrideCallback !== null && overrideCallback !== void 0 ? overrideCallback : callback) === null || _a === void 0 ? void 0 : _a();
        resolve(value);
      }, overrideTime !== null && overrideTime !== void 0 ? overrideTime : time);
    });
  }, [time, callback]);
  useWillUnMountEffect(clear);
  return {
    set: set,
    clear: clear,
    waiting: waiting
  };
}